export const textLang: any = {
    jp: {
        sureBeforeDesc1: '再チェックインを確認しますか？',
    },
    us: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    ca: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    au: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    eu: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    uk: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    de: {
        sureBeforeDesc1: 'Bestätigen Sie, um den Check-in nachzuholen?',
    },
    es: {
        sureBeforeDesc1: '¿Confirmar para recuperar visitas?',
    },
    fr: {
        sureBeforeDesc1: 'Confirmez-vous pour rattraper une présence manquée ?',
    },
    it: {
        sureBeforeDesc1: 'Confermi per recuperare un check-in?',
    },
    kr: {
        sureBeforeDesc1: '체크인 보충을 확인하시겠습니까?',
    },
    za: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    br: {
        sureBeforeDesc1: 'Confirmar compensação de check-in?',
    },
    mx: {
        sureBeforeDesc1: '¿Deseas confirmar la recuperación de registro?',
    },
    ph: {
        sureBeforeDesc1: 'Confirm to make up for check-in?',
    },
    nl: {
        sureBeforeDesc1: 'Bevestigt u een compensatie voor check-in?',
    },
};
